/*eslint no-inline-comments: "error"*/

/*
function that receives a phone number for example (818) 977-8649 and returns a formated version of the phone type and phone number
 */
export const formatPhone = (phoneNumber, phoneType) => {
    if (!phoneNumber) return "";

    let formatedPhone = phoneNumber;
    if (phoneType) {
        formatedPhone = `${phoneType}: ${phoneNumber}`;
    }

    return formatedPhone;
};

/*
 function that receives a list of phones and return the list separted by /
 */
export const formatPhones = (phoneNumbers) => {
    if (!phoneNumbers) return "";
    const phones = phoneNumbers.filter((phone) => Boolean(phone.number) && Boolean(phone.type));

    const formatedPhones = phones.map((phone) => {
        return formatPhone(phone.number, phone.type);
    });

    return formatedPhones.join(" / ");
};
